import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import JBProductImage from 'components/essentials/JBImage/JBProductImage';
import ProductCardImageComingSoon from './ProductCardImageComingSoon';
const ProductCardStudioImage = t0 => {
  const $ = _c(7);
  const {
    cropData,
    disableImageLazyLoading,
    image,
    isMobile
  } = t0;
  if (!image) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ProductCardImageComingSoon />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const imageWidthAndHeight = isMobile ? 265 : 341;
  const t1 = !cropData ? "center" : undefined;
  const t2 = !disableImageLazyLoading;
  let t3;
  if ($[1] !== cropData || $[2] !== image || $[3] !== imageWidthAndHeight || $[4] !== t1 || $[5] !== t2) {
    t3 = <JBProductImage ar="1:1" className="w-full h-full" crop={t1} cropFormat="1x1" crops={cropData} enableCrops={true} height={imageWidthAndHeight} lazy={t2} src={image} width={imageWidthAndHeight} />;
    $[1] = cropData;
    $[2] = image;
    $[3] = imageWidthAndHeight;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
ProductCardStudioImage.propTypes = {
  cropData: PropTypes.object,
  disableImageLazyLoading: PropTypes.bool,
  image: PropTypes.string,
  isMobile: PropTypes.bool
};
export default ProductCardStudioImage;